<div class="rv-grid-large page-header">
  <div class="grid-inner">
    <div class="column-small-12 rv-flex">
      <div class="title rv-flex max-width">
        <span #breadcrumbsContainer>
          <ng-content select="breadcrumbs"></ng-content>
        </span>
        {{ breadcrumbsContainer.children.length > 0 ? '&nbsp;' : '' }}
        <h1 #pageHeader [focusOnInit]="true" tabindex="-1">
          <ng-content select="[page-header]"></ng-content>
        </h1>
      </div>
      <div class="page-actions rv-flex">
        <ng-content select="[page-actions]"></ng-content>
      </div>
    </div>
  </div>
</div>
<div class="content-container" #contentContainer>
  <div class="content"><ng-content></ng-content></div>
</div>
